import { AWS_CLOUDFROND_BASE_URL } from "../config-global.jsx";

// checks if there is a pwa manifest and if there is, it adds it to the head
export const PwaHandler = ({ icon, handler }) => {
    const head = document.getElementsByTagName('head')[0];
    const manifestLink = head.querySelector('link[rel="manifest"]');

    // add or update manifest link
    if (handler && AWS_CLOUDFROND_BASE_URL) {
        const normalizedHandler = String(handler).toLowerCase().replaceAll(' ', '_');
        const manifestUrl = `${AWS_CLOUDFROND_BASE_URL}/${normalizedHandler}_pwa_manifest.json`;
        if (manifestLink) {
            manifestLink.setAttribute('href', manifestUrl);
        } else {
            const newManifestLink = document.createElement('link');
            newManifestLink.rel = 'manifest';
            newManifestLink.href = manifestUrl;
            head.appendChild(newManifestLink);
        }
    }

    return null;
}

